import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { reports as reportsApi } from 'redux/modules/api'
import { notification, logError, modal } from 'redux/modules/app'
// import appConfig from 'config'
import fetchFile from 'helpers/fetchFile'
import { participantsExport, participantsGridExport } from 'models/participants'
import { leadersExport } from 'models/leaders'
import {
  organizationExport,
  organizationForNaoExport,
  independentAwardCentreExport,
  nationalOfficesExport,
  regionsExport
} from 'models/organization'
import {
  awardOfficeExport,
  awardOfficeLocallyExport,
  registrationsAwardLeadersExport,
  registrationsAwardUnitsExport,
  registrationsParticipantsExport
} from 'models/tasks'
import { ajEventsExport } from 'models/aj-events'
import { awardProgressOverviewExport } from 'models/awards'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'


function decorator(config = {}) {
  return ComposedComponent => {
    @injectIntl
    @connect(
      ({ api, auth }) => ({
        reports: api.reports,
        user: auth.user,
        activeOrganization: auth.organization
      }),
      { ...reportsApi, notification, modal, logError }
    )
    class Reports extends Component {
      static propTypes = {
        user: PropTypes.object.isRequired,
        activeOrganization: PropTypes.object.isRequired,
        getReports: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        createAuthCode: PropTypes.func.isRequired,
        generateXlsExport: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        update: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired
      }

      state = {
        isReportPreloading: false
      }

      componentDidMount() {
        config.list && this.handleGetReports()
      }

      handleGetReports = () => {
        this.props
          .getReports()
          .then(this.handleCreateAuthCodes)
          .catch(this.handleError)
      }

      handleUpdateReport = (id, data) => {
            this.props
                .update(id, data)
                .then(() => {
                    this.handleGetReports()
                    this.props.modal(null)
                })
                .catch(this.handleError)
        }


      handleGenerateExport = ({ toExport, exportName, exportSchemeValue, additionalParams = {}}) => {
        const { intl, user, activeOrganization } = this.props

        let data = {
          title: exportName
        }

        this.setState({
          isReportPreloading: true
        })

        toExport()
          .then(({ body } = {}) => {
            console.log(body)
            this.setState({
              isReportPreloading: false
            })

            if (exportSchemeValue === 'participants') {
              data = {
                ...data,
                lines: participantsExport.line(body, intl),
                headers: participantsExport.headers(intl)
              }
            }

            if(exportSchemeValue === 'participants-grid') {
              const remappedFilters = body.filter.map(({ attributeName, name, value }) => ({
                property: name || attributeName,
                value: Array.isArray(value)
                  ? value.join(', ')
                  : value || ''
              }))

              data = {
                ...data,
                lines: participantsGridExport.line(body.list),
                headers: participantsGridExport.headers(intl),
                filters: remappedFilters
              }
            }

            if (exportSchemeValue === 'leaders') {
              data = {
                ...data,
                lines: leadersExport.line(body, intl),
                headers: leadersExport.headers(intl)
              }
            }

            if (
              exportSchemeValue === 'award-units' &&
              getActiveRole(activeOrganization) === ROLES.NAO_STAFF.u
            ) {
              const { isOrgLabelsEnabled } = additionalParams

              data = {
                ...data,
                lines: organizationForNaoExport.line(body, intl, isOrgLabelsEnabled),
                headers: organizationForNaoExport.headers(intl, isOrgLabelsEnabled)
              }
            }

            if (
              exportSchemeValue === 'award-units' &&
              getActiveRole(activeOrganization) !== ROLES.NAO_STAFF.u
            ) {
              data = {
                ...data,
                lines: organizationExport.line(body, intl),
                headers: organizationExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'iacs') {
              data = {
                ...data,
                lines: independentAwardCentreExport.line(body, intl),
                headers: independentAwardCentreExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'naos') {
              data = {
                ...data,
                lines: nationalOfficesExport.line(body, intl),
                headers: nationalOfficesExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'iacs') {
              data = {
                ...data,
                lines: nationalOfficesExport.line(body, intl),
                headers: nationalOfficesExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'regions') {
              data = {
                ...data,
                lines: regionsExport.line(body, intl),
                headers: regionsExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'oas') {
              data = {
                ...data,
                lines: regionsExport.line(body, intl),
                headers: regionsExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'aj-events') {
              data = {
                ...data,
                lines: ajEventsExport.line(body, intl),
                headers: ajEventsExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'awards-office') {
              const { includeCountry } = additionalParams;

              data = {
                ...data,
                lines: awardOfficeExport.line(body, intl, includeCountry),
                headers: awardOfficeExport.headers(intl, includeCountry)
              }
            }

            if (exportSchemeValue === 'awards-office-locally') {
              const { includeCountry } = additionalParams;

              data = {
                ...data,
                lines: awardOfficeLocallyExport.line(body, intl, includeCountry),
                headers: awardOfficeLocallyExport.headers(intl, includeCountry)
              }
            }

            if (exportSchemeValue === 'registrations-award-leader') {
              data = {
                ...data,
                lines: registrationsAwardLeadersExport.line(body, intl),
                headers: registrationsAwardLeadersExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'registrations-award-units') {
              data = {
                ...data,
                lines: registrationsAwardUnitsExport.line(body, intl),
                headers: registrationsAwardUnitsExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'registrations-participants') {
              data = {
                ...data,
                lines: registrationsParticipantsExport.line(body, intl),
                headers: registrationsParticipantsExport.headers(intl)
              }
            }

            if (exportSchemeValue === 'award-progress-overview') {
              const remappedFilters = body.filter.map(({ attributeName, name, value }) => ({
                property: name || attributeName,
                value: Array.isArray(value)
                  ? value.join(', ')
                  : value || ''
              }))

              data = {
                ...data,
                lines: awardProgressOverviewExport.line(body.list, intl),
                headers: awardProgressOverviewExport.headers(intl),
                filters: remappedFilters
              }
            }

            this.props
              .generateXlsExport(data)
              .then(res => {
                fetchFile(res.body.url, user)
              })
              .catch(this.handleError)
          })
          .catch(this.handleError)

        // const data = {
        //   title: 'participants',
        //   headers: ['Name', 'Birth date'],
        //   filters: [
        //     { property: 'Award Level', value: 'Gold' },
        //     { property: 'Participant Name', value: 'Jan M' },
        //     { property: 'Paid By', value: 'Parent' }
        //   ],
        //   lines: [
        //     { line: ['John Foo', '1.3.2010'] },
        //     { line: ['John Foo2', '1.3.2011'] }
        //   ]
        // }
      }

      handleCreateAuthCodes = () => {
        config.createAuthCodes &&
          this.props.createAuthCode().catch(this.handleError)
      }

      handleError = err => {
        this.props.logError(err)
        this.setState({
          isReportPreloading: false
        })
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            // getReportAuthCode={this.handleGetReportAuthCode}
            onGenerateExport={this.handleGenerateExport}
            isReportPreloading={this.state.isReportPreloading}
            onUpdateReport={this.handleUpdateReport}
          />
        )
      }
    }
    return Reports
  }
}

export default decorator
